import React from 'react';
import {
  HELP_CENTER_SUBTITLE,
  HELP_CENTER_TITLE,
  HELP_DEFAULT_SECTION_ID,
  HELP_SECTIONS,
} from '../../constants';
import {
  ContentGrid,
  DocContentLink,
  DocsContent,
  HelpQuestionList,
  ParagraphText,
  TableOfContentsWrapper,
  SectionTitle,
  TabSectionsContainer,
} from '../../styles';
import { getDocsRouteFromDocPath } from '../../utils';
import { TableOfContents } from '../TableOfContents/TableOfContents';

interface HelpTabContentProps {
  selectedTabId: string;
  sectionId?: string;
}

export function HelpTabContent({
  selectedTabId,
  sectionId,
}: HelpTabContentProps) {
  const activeSectionId = sectionId ?? HELP_DEFAULT_SECTION_ID;

  const activeSection =
    HELP_SECTIONS.find(section => section.id === activeSectionId) ??
    HELP_SECTIONS[0];

  return (
    <ContentGrid>
      <DocsContent>
        <TabSectionsContainer>
          <section>
            <SectionTitle variant="h4">{HELP_CENTER_TITLE}</SectionTitle>
            <ParagraphText>{HELP_CENTER_SUBTITLE}</ParagraphText>
          </section>

          <section>
            <SectionTitle variant="h5">{activeSection.title}</SectionTitle>
            <HelpQuestionList>
              {activeSection.questions.map(question => {
                const navigatePath = activeSection.navigatePaths[question];
                const route = navigatePath
                  ? getDocsRouteFromDocPath(navigatePath, 'help')
                  : undefined;

                return (
                  <li key={question}>
                    {route ? (
                      <DocContentLink to={route}>{question}</DocContentLink>
                    ) : (
                      <span>{question}</span>
                    )}
                  </li>
                );
              })}
            </HelpQuestionList>
          </section>
        </TabSectionsContainer>
      </DocsContent>

      <TableOfContentsWrapper>
        <TableOfContents selectedTabId={selectedTabId} />
      </TableOfContentsWrapper>
    </ContentGrid>
  );
}
